import Flex from "components/grid/Flex";
import { useTranslation } from "react-i18next";
import HistoryContainerAndTitle from "./HistoryContainerAndTitle";
import { isAnyPresent, makeHistory } from "../../HistoryUtils";
import ConditionalLabel from "./ConditionalLabel";
import ConditionalLabelAndValue from "./ConditionalLabelAndValue";
import { Typography } from "@material-ui/core";
import { packageYears } from "../section/CardiovascularForm";

const CardiovascularRiskFactorsHistory = ({ anamnesisHistory }) => {
    const { t } = useTranslation();
    const history = makeHistory(anamnesisHistory);
    const isVisible = isAnyPresent(anamnesisHistory, [
        "hasTimePressureAndStress",
        "hasHealthyDiet",
        "hasCardiovascularDisease",
        "currentPulseCount",
        "currentBloodPressure",
        "hasSufferingFromHypercholesterolemia",
        "hypercholesterolemiaState",
        "hasSufferingFromDiabetes",
        "diabetesState",
        "smokeStatus",
        "smokeYear",
        "smokeNumberOfPacks",
        "smokeNumberUnit",
        "familyHeartAttackOrStrokeStatus",
        "sportStatus",
        "alcoholDrinkingStatus",
        "alcoholDrinkCountPerWeek",
    ]);
    return (
        <HistoryContainerAndTitle title={t(`anamnesis.cardiovascular.title`)} isVisible={isVisible}>
            <Flex item grow={0} container column style={{ margin: "5px 0px" }}>
                <ConditionalLabel
                    {...{
                        value: history.getLatestValueOf("hasTimePressureAndStress"),
                        label: t("anamnesis.cardiovascular.hasTimePressureAndStressHistory"),
                    }}
                />
                <ConditionalLabel
                    {...{
                        value: history.getLatestValueOf("hasHealthyDiet"),
                        label: t("anamnesis.cardiovascular.hasHealthyDiet"),
                    }}
                />
                <Flex item container grow={0} gap={10}>
                    <ConditionalLabel
                        {...{
                            value: history.getLatestValueOf("hasCardiovascularDisease"),
                            label: `Z.n. ${t("anamnesis.cardiovascular.hasCardiovascularDisease")}`,
                        }}
                    />
                    <ConditionalLabelAndValue
                        {...{
                            value: history.getLatestValueOf("currentPulseCount"),
                            label: t("anamnesis.cardiovascular.currentPulseCountPlaceholder"),
                            skipSeparator: true,
                        }}
                    />
                    <ConditionalLabelAndValue
                        {...{
                            value: history.getLatestValueOf("currentBloodPressure"),
                            label: t("anamnesis.cardiovascular.currentBloodPressurePlaceholder"),
                            skipSeparator: true,
                        }}
                    />
                </Flex>
                <Flex item container grow={0} gap={10}>
                    <ConditionalLabelAndValue
                        {...{
                            switchValue: history.getLatestValueOf("hasSufferingFromHypercholesterolemia"),
                            value: history.getLatestValueOf("hypercholesterolemiaState")
                                ? t(`global.${history.getLatestValueOf("hypercholesterolemiaState").toLowerCase()}`)
                                : "",
                            label: `Z.n. ${t("anamnesis.cardiovascular.hypercholesterolemia")}`,
                            translationKey: "global",
                        }}
                    />
                </Flex>
                <Flex item container grow={0} gap={10}>
                    <ConditionalLabelAndValue
                        {...{
                            switchValue: history.getLatestValueOf("hasSufferingFromDiabetes"),
                            value: history.getLatestValueOf("diabetesState")
                                ? t(`global.${history.getLatestValueOf("diabetesState").toLowerCase()}`)
                                : "",
                            label: `Z.n. ${t("anamnesis.cardiovascular.hasSufferingFromDiabetesHistory")}`,
                            translationKey: "global",
                        }}
                    />
                </Flex>
                <Flex item container grow={0} gap={10} alignItems={"center"}>
                    <ConditionalLabelAndValue
                        {...{
                            switchValue: history.getLatestValueOf("smokeStatus"),
                            value:
                                history.getLatestValueOf("smokeYear") &&
                                history.getLatestValueOf("smokeNumberOfPacks") &&
                                history.getLatestValueOf("smokeNumberUnit") ? (
                                    <>
                                        <span style={{ fontWeight: "bold" }}>
                                            {packageYears(history.getLatestValueOf("smokeYear"), {
                                                value: history.getLatestValueOf("smokeNumberOfPacks"),
                                                unit: history.getLatestValueOf("smokeNumberUnit"),
                                            }).toFixed(2)}
                                            &nbsp;
                                        </span>
                                        Packungsjahre
                                    </>
                                ) : (
                                    ""
                                ),
                            label: t("anamnesis.cardiovascular.smokeStatus"),
                        }}
                    />
                </Flex>
                <ConditionalLabel
                    {...{
                        value: history.getLatestValueOf("familyHeartAttackOrStrokeStatus"),
                        label: t("anamnesis.cardiovascular.familyHeartAttackOrStrokeStatus"),
                    }}
                />
                <ConditionalLabel
                    {...{
                        value: history.getLatestValueOf("sportStatus"),
                        label: t("global.active") + " " + t("anamnesis.cardiovascular.sportStatus"),
                    }}
                />
                <Flex item container grow={0} gap={10} alignItems={"center"}>
                    <ConditionalLabelAndValue
                        {...{
                            switchValue: history.getLatestValueOf("alcoholDrinkingStatus"),
                            value: history.getLatestValueOf("alcoholDrinkCountPerWeek")
                                ? <Typography>
                                    {history.getLatestValueOf("alcoholDrinkCountPerWeek") +
                                        " " +
                                        t(`anamnesis.cardiovascular.alcoholDrinkCountPerWeek`)}
                                </Typography>
                                : "",
                            label: t("anamnesis.cardiovascular.alcoholDrinkingStatus"),
                        }}
                    />
                </Flex>
            </Flex>
        </HistoryContainerAndTitle>
    );
};

export default CardiovascularRiskFactorsHistory;
